import { render, staticRenderFns } from "./AddPurchases.vue?vue&type=template&id=40a7e40e&scoped=true"
import script from "./AddPurchases.vue?vue&type=script&lang=js"
export * from "./AddPurchases.vue?vue&type=script&lang=js"
import style0 from "./AddPurchases.vue?vue&type=style&index=0&id=40a7e40e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a7e40e",
  null
  
)

export default component.exports